export default defineNuxtRouteMiddleware((to, _from) => {
  if (process.client) {
    const roles = to.meta.roles as Array<string>
    if (roles && roles.length > 0) {
      const session = useAuth().session.value
      if (session) {
        const hasPermission = session.role && roles.includes(session.role)
        if (!hasPermission) {
          setTimeout(() => {
            showError({ message: "Vous n'avez pas accès à cette page", statusCode: 403 })
          }, 100)
        }
      }
    }
  }
})
